import { atom } from 'jotai';

export interface IAuditListItem {
  id?: string;
  requirement_text: string;
  position?: number;
  created_at?: string;
  updated_at?: string;
}

export interface IAuditListItemInput extends Omit<IAuditListItem, 'id' | 'created_at' | 'updated_at'> {}

export const auditListItemsAtom = atom<IAuditListItem[]>([]);
export const auditListItemsLoadingAtom = atom<boolean>(false);


